export const FORM_ID = 'inquiry-form';

// Booking Review Form fields
export const FORM_OCCASION = 'occasion';
export const FORM_MESSAGE = 'message';
export const FORM_DEPARTURE_TIME = 'departureTime';
export const FORM_RETURN_TIME = 'returnTime';
export const FORM_ALTERNATE_DATE_1 = 'alternateDateOne';
export const FORM_ALTERNATE_DATE_1_END = 'alternateDateOneEnd';
export const FORM_ALTERNATE_DATE_2 = 'alternateDateTwo';
export const FORM_ALTERNATE_DATE_2_END = 'alternateDateTwoEnd';

export const PARAM_INQUIRY_ID = 'inquiryId';

export const COMMENT_TEXT_LIMIT = 250;
